<template>
  <div class="video" ref="videoContainer">
    <div class="video__box">
      <transition name="Anim__opacity">
        <video 
          v-if="isVideoVisible"
          muted
          playsinline
          preload="metadata"
          :height="`${LIST_ITEM_HEIGHT}px`"
          ref="video"
          :poster="poster || undefined"
          @loadedmetadata="handleVideoLoaded()"
        >
          <source :src="props.data.url" type="video/mp4" :height="`${LIST_ITEM_HEIGHT}px`">
        </video>
      </transition>
      <PlayIcon class="video__play" />
      <time>{{ duration }}</time>
    </div>
    <span class="video__caption">{{ props.data.caption }}</span>
  </div>
</template>

<script setup>
  import { ref, onMounted, onBeforeUnmount } from 'vue';
  import { Props } from './props';
  import { LIST_ITEM_HEIGHT } from '../../config/config';
  import { observeOnce, unobserve } from '@shared/services/observers/intersectionObservers.js';
  //---------------------------------------------
  import PlayIcon from '../../svg/PlayIcon.vue';
  //---------------------------------------------
  const props = defineProps(Props());
  //---------------------------------------------
  const video = ref(null);
  const duration = ref(null);
  const poster = ref(null);
  const videoContainer = ref(null);
  const isVideoVisible = ref(false);
  //---------------------------------------------
  onMounted(() => {
    if(!videoContainer.value) return;
    observeOnce(videoContainer.value, () => { isVideoVisible.value = true; });
  });
  onBeforeUnmount(() => {
    if(!videoContainer.value) return;
    unobserve(videoContainer.value); 
  });
  //---------------------------------------------
  //Функция для создания постера из видео
  const createVideoPoster = async () => {
    try {
      await new Promise((resolve) => {
        const onCanPlay = () => {
          video.value.removeEventListener('canplay', onCanPlay);
          resolve();
        };
        video.value.addEventListener('canplay', onCanPlay);
        if (video.value.readyState < 2) {
          video.value.currentTime = 0.1;
        }
      });
      const canvas = document.createElement('canvas');
      canvas.width = video.value.videoWidth;
      canvas.height = video.value.videoHeight;
      const ctx = canvas.getContext('2d');
      ctx.drawImage(video.value, 0, 0, canvas.width, canvas.height);
      poster.value = canvas.toDataURL('image/jpeg');
    } catch (error) {
      console.error('Error generating video poster:', error);
    }
  };
  //Обработчик загрузки метаданных видео
  const handleVideoLoaded = async () => {
    duration.value = formatDuration();
    if (isIOS() || isSafari()) {
      await createVideoPoster();
    }
  };
  //Форматирование длительности видео
  const formatDuration = () => {
    const seconds = video.value.duration;
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = Math.floor(seconds % 60);
    return `${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
  };
  //Проверка на iOS
  const isIOS = () => {
    return /iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  };
  //Проверка на Safari
  const isSafari = () => {
    return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  };
</script>

<style lang="scss" scoped>
  @import './styles.scss';
</style>
